export default function ENTJ(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “فرمانده”</h1>{" "}
          <blockquote>
            <p>
              زمانتان محدود است، پس آن را با زندگی کردن بجای شخص دیگری هدر
              ندهید. به دام جزم&zwnj;اندیشی نیفتید - که به معنای زندگی کردن با
              نتایج حاصل از تفکر دیگران است. اجازه ندهید سر و صدای نظرات دیگران
              صدای درونی خودتان را غرق کند. و از همه مهمتر، شجاعت پیروی از قلب و
              شهود خود را داشته باشید. آن&zwnj;ها می&zwnj;دانند شما واقعاً
              می&zwnj;خواهید به چه کسی تبدیل شوید. تمام چیزهای دیگر در درجه دوم
              اهمیت است.
            </p>{" "}
            <footer>Steve Jobs</footer>
          </blockquote>{" "}
          <p>
            فرماندهان، رهبرانی بالفطره هستند. افراد دارای این گونه شخصیتی تجسم
            کاریزما و اعتماد به نفس هستند و قدرت را طوری به نمایش می&zwnj;گذارند
            که دیگران را برای هدفی مشترک گرد هم می&zwnj;آورند. اما فرماندهان
            برخلاف همتای حساس&zwnj;تر خود یعنی پیشگامان، سطح اغلب
            بی&zwnj;رحمانه&zwnj;ای از عقلانیت دارند و از انگیزه، اراده و ذهن تیز
            خود برای رسیدن به هر هدفی که برای خود تعیین کرده&zwnj;اند، استفاده
            می&zwnj;کنند. شاید خیلی خوب باشد که آنها تنها سه درصد از جمعیت را
            تشکیل می&zwnj;دهند تا مبادا به پایمال کردن سایر گونه&zwnj;های شخصیتی
            ترسوتر و حساس&zwnj;تر بپردازند که بقیه جمعیت جهان را تشکیل
            می&zwnj;دهند - اما باید به&zwnj;خاطر بسیاری از شرکت&zwnj;ها و
            مؤسساتی که هر روز با آنها مواجهیم باید قدردان فرماندهان باشیم.
          </p>{" "}
          <h2>شادی در لذت موفقیت نهفته است</h2>{" "}
          <p>
            اگر فرماندهان عاشق چیزی باشند، آن چیز چالشی خوب اعم از بزرگ یا کوچک
            است و عمیقاً معتقدند که اگر زمان و منابع کافی در اختیارشان باشد،
            می&zwnj;توانند به هر هدفی دست یابند. این کیفیت باعث می&zwnj;شود
            افراد دارای گونه شخصیتی فرمانده به کارآفرینانی درخشان تبدیل شوند و
            توانایی آنها برای تفکر استراتژیک و داشتن تمرکز طولانی&zwnj;مدت در
            حین اجرای هر مرحله از برنامه&zwnj;های خود با اراده و دقت، باعث
            می&zwnj;شود به رهبرانی قدرتمند در کسب و کار تبدیل گردند. این اراده
            اغلب نوعی رسالت درونی است، چرا که فرماندهان با اراده مطلق خود به سمت
            اهدافشان حرکت می&zwnj;کنند حال آنکه دیگران ممکن است تسلیم شوند و
            مهارت&zwnj;های اجتماعی آنها به این معنا است که به احتمال زیاد سایر
            افراد را با خود همراه می&zwnj;کنند و در این روند به نتایجی چشمگیر
            دست می&zwnj;یابند.
          </p>{" "}
          <div className="scene"></div>{" "}
          <p>
            فرماندهان در پشت میز مذاکره، چه در محیط شرکت یا در هنگام خریدن یک
            خودرو، مسلط، بی&zwnj;امان، و بی&zwnj;رحم هستند. دلیلش این نیست که
            آنها فی&zwnj;نفسه سنگدل یا شرور هستند - بلکه مسئله اینجا است که
            شخصیت فرمانده واقعاً از چالش و نبرد حاضر جوابی در محیط لذت
            می&zwnj;برد و اگر طرف مقابل نتواند مقاومت کند، هیچ دلیلی ندارد که
            فرمانده از پیروزی نهایی خود چشم&zwnj;پوشی کند.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              شاید تفکری که در ذهن فرمانده جریان دارد این باشد "هیچ اهمیتی
              نمی&zwnj;دهم که مرا ح*****ه بی&zwnj;رحمی بدانی، به شرطی که ح*****ه
              کارآمدی باشم".
            </p>
          </blockquote>{" "}
          <p>
            اگر کسی باشد که فرمانده به وی احترام بگذارد، آن فرد کسی است که از
            لحاظ فکری قادر است با دقت و کیفیتی همانند خودش با وی برابری کند.
            شخصیت فرمانده مهارت خاصی در شناخت استعدادهای دیگران دارد و این امر
            به وی هم در زمینه تیم&zwnj;سازی کمک می&zwnj;کند (زیرا هیچ کس، هر
            چقدر هم که باهوش باشد نمی&zwnj;تواند همه چیز را به تنهایی انجام
            دهد)، و هم مانع از آن می&zwnj;شود که فرمانده غرور و برتری بیش از حدی
            نشان دهد. با این حال، این افراد مهارت خاصی دیگری نیز در برشمردن شکست
            دیگران با بی&zwnj;رحمی فراوان دارند و این جا است که فرماندهان واقعاً
            دچار دردسر می&zwnj;شوند.
          </p>{" "}
          <h2>پرورش دادن علم روابط انسانی</h2>{" "}
          <p>
            بیان عاطفی در مورد هیچ گونه شخصیتی در گروه نقش تحلیلگر صادق نیست،
            اما فاصله گرفتن فرماندهان از احساسات خود به دلیل ماهیت
            اجتماعی&zwnj;شان کاملاً مشهود است و این مسئله به&zwnj;طور مستقیم
            توسط طیف بسیار گسترده&zwnj;تری از افراد احساس می&zwnj;شود. به خصوص
            در محیط حرفه&zwnj;ای، فرماندهان به&zwnj;سادگی حساسیت خود را نسبت به
            کسانی که آنها را ناکارآمد، بی&zwnj;کفایت یا تنبل می&zwnj;دانند،
            سرکوب می&zwnj;نمایند. در مورد افراد دارای گونه شخصیتی فرمانده، نشان
            دادن عواطف به معنای ضعف نشان دادن است و با این رویکرد به&zwnj;راحتی
            می&zwnj;توان برای خود دشمن تراشید - فرماندهان به&zwnj;خوبی این مسئله
            را به خاطر دارند که کاملاً به داشتن تیمی مؤثر وابسته هستند، نه فقط
            برای رسیدن به اهداف خود، بلکه همچنین در خصوص اعتبار و بازخورد خود،
            چیزی که فرماندهان نسبت به آن بسیار حساس هستند.
          </p>{" "}
          <p>
            فرماندهان به&zwnj;راستی منبع نیرو هستند، و اغلب تصویری که از خود
            ارائه می&zwnj;دهند تصویری فراتر از افراد عادی است - و اغلب اوقات خود
            نیز چنین هستند. هرچند افراد دارای این گونه شخصیتی باید به یاد داشته
            باشند که جایگاهشان فقط ناشی از اعمال خودشان نیست، بلکه در عین حال
            ناشی از اقدامات تیمی است که آنها را سرپا نگهداشته است و مهم است که
            کمک&zwnj;ها، استعدادها و نیازهای شبکه حمایتی خود را به ویژه از منظر
            عاطفی تشخیص دهند. اگرچه شخصیت فرمانده باید ذهنیت "تظاهر کن که داری
            تا وقتی که بتوانی آن را داشته باشی" را در پیش بگیرد، اما اگر قادر به
            در نظر گرفتن تمرکز عاطفی مناسب در کنار نقاط قوت فراوان خود باشد،
            روابطی عمیق و رضایت&zwnj;بخش را کسب خواهد کرد و قادر است در تمام
            چالش&zwnj;های پیش روی خود به پیروزی برسد.
          </p>
        </article>
      </div>
    </div>
  );
}
